import React, { Component } from "react";
import Header from "../Header";
import Menu from "../Menu";
import Loader from '../Loader';
import { CONFIG, checkAuth, getLoggedInData } from "../../helpers/Common";

import { SURGEON } from "../../services/Surgeon";
import PendingPatientListItem from "./components/PendingPatientListItem";
import "../../assets/css/new_style.css";
import "../../assets/css/pending-patient-symptom.css";
import $ from 'jquery';

class PendingPatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: '',
      surgeonId: '',
      pendingPatientsData: new Array(),
      activePage: 0,
      isLoading: true,
      pageCount: 0,
      totalRecordsCount: 0,
      totalPages:1,
      paginationItems: new Array(),
      message:''
    };
    this.handlePage       = this.handlePage.bind(this)
    this.getLoggedInData  = getLoggedInData.bind(this)// Import from common
    this.checkAuth        = checkAuth.bind(this)// Import from common
  }

  componentWillMount() {
   
    checkAuth();
    let userData = getLoggedInData();
    this.setState({
      userData: userData,
      surgeonId: userData.user_id
    });
    

  }

  componentDidMount() {

    //Reset All Local Database fields

    localStorage.setItem("newData",'');
    localStorage.setItem("editQuest",'');
    localStorage.setItem('saveQuest','');

    checkAuth();
    let userData = getLoggedInData();
    this.setState({
      userData: userData,
      surgeonId: userData.user_id
    });
    this.makeRequest();
  }

  makeRequest =  e => {
    // let LoginResponse = SURGEON.getPendingPatientsNarrative(this.state.userData.user_id)
   
     SURGEON.getPendingPatientsNarrative(this.state.surgeonId, this.state.activePage).then(res => {
        if (res.data.header.error == 0) {
          this.setState({
            pendingPatientsData: res.data.body.details.data,
            isLoading: false,
            totalPages: res.data.body.details.total_pages, //get from api .length
          });
          let paginationItems = new Array();
          for(let i= 1; i<(this.state.totalPages); i++)
          {
            paginationItems.push(i);
          }
          
          this.setState({
            paginationItems: paginationItems,
          });
        }
        if(res.data.header.error==1){
          this.setState({
              isLoading: false,
              message:res.data.header.message
          });
          
      }
        if(res.data.header.error==400){
          localStorage.removeItem('userData');
          this.props.history.push('/surgeon/login');
        }
      })
      .catch(err => {
        return err;
      });
  }

  handlePage = e => {
    let activePage =  Number(e.target.id);
    this.setState({
      activePage:activePage
    });
    var ref = this;
    setTimeout(function(){ref.makeRequest(); }, 300);
  }
  
  handleArrow = (e) => {
    const { activePage, totalPages } = this.state;
    var ref = this;
    if (e.target.name === 'prev' && activePage - 1 >= 0) {
      this.setState({
        activePage: activePage - 1,
      });
      setTimeout(function(){ref.makeRequest(); }, 300);
    } else 
    if (e.target.name === 'next' && activePage + 1 < totalPages) {
      this.setState({
        activePage: activePage + 1,
      });
      setTimeout(function(){ref.makeRequest(); }, 300);
    }

  }

  handleAction = (id) => {
    let patientData = this.state.pendingPatientsData.find(x => x.id === id);
    this.props.history.push({
      pathname: '/surgeon/patient/narrative/'+id,
      state: { patientData: patientData }
    });
    // this.props.location.state.patientData
  }

  render() {

    $(".marker").remove();

    let items = [];
    let count = 0;
    for (let number = 1; number <= this.state.totalPages; number++) {
      items.push(
        <a key={number} id={count} className={count === this.state.activePage ? 'active' : ''} onClick={this.handlePage} name={number}>
          {number}
          
        </a>
      );
      count++;
    }

    return (
      <React.Fragment>
        <Header
          title="Pending Patient Symptoms"
          titleImage="pending-symptom-img.png"
        />
        <Menu />
        <section className="pending-patient-symptoms">
          <div className="container">
            <ul className="patient-symptoms-detail">
              {
                this.state.isLoading == false &&
                this.state.pendingPatientsData.map(data => (
                  <PendingPatientListItem key={data.id} pendingPatientsData={data} handleAction={this.handleAction} />
                ))
              }
            </ul>
            {
                this.state.message &&
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="sypmtom-info no--data">
                            <h2>
                            {this.state.message}
                            </h2>
                        </div>
                    </div>
                </div>
            }
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {
                this.state.isLoading != false &&
                <Loader />
              }
            </div>
          </div>
        </section>
        <section className="pagination-sec">
          <div className="container disable-select">
            {
               (this.state.isLoading == false && this.state.totalPages > 1) &&
              <div className="pagination">
                <a onClick={this.handleArrow} name={'prev'}>&laquo;</a>
                {items}
                <a onClick={this.handleArrow} name={'next'}>&raquo;</a>
              </div>
            }
          </div>
        </section>
      </React.Fragment>
    );
  }

  

}
export default PendingPatients;